export const userActions = ['Suspend User'];

export const validStatuses = [
  'Pre-qualification approved - Awaiting customer Authorization',
  'Pre-qualification declined',
  'Awaiting Delivery',
  'Awaiting customer signature',
  'Contract expired',
  'Awaiting customer signature',
  'Awaiting dealer signature',
  'Contract signed',
  'Contract funded',
  'Error',
  'Awaiting signatures',
  'Pending Manual Review',
  'Funded',
];

export const buildDealDisabledStatuses = [
  'dealer-finalised',
  'customer-reviewed',
  'prequal-manual-review',
  'prequal-review',
  'pending-review',
  'fund-complete',
];

export const deliveryDateDisabledStatuses = [
  'contract-signed',
  'customer-reviewed',
  'prequal-review',
  'fund-complete',
];

export const caBackendProducts = ['Theft Deterrent Device', 'Surface Protection Product', 'EV Charging Station'];

export const caFrontendProducts = ['Emissions Testing Charge', 'State Emissions Certification Fee or Exemption Fee'];
